import React from 'react';
import '../styles/SectionContent.css';

const Education = () => {
  return (
    <div className="section-content">
      <div className="section-header">
        <h2>Patient Education</h2>
        <button className="primary-btn">+ Add Resource</button>
      </div>
      
      <div className="content-grid">
        <div className="content-card">
          <div className="card-icon">🫀</div>
          <h3>Heart Health Guidelines</h3>
          <p>Comprehensive guide on maintaining cardiovascular health</p>
          <div className="card-stats">
            <span>156 views</span>
            <span>Published</span>
          </div>
        </div>
        
        <div className="content-card">
          <div className="card-icon">🍎</div>
          <h3>Nutrition & Diet Plans</h3>
          <p>Evidence-based dietary recommendations for various conditions</p>
          <div className="card-stats">
            <span>89 views</span>
            <span>Published</span>
          </div>
        </div>
        
        <div className="content-card">
          <div className="card-icon">🏃‍♂️</div>
          <h3>Exercise & Rehabilitation</h3>
          <p>Physical therapy and exercise programs for recovery</p>
          <div className="card-stats">
            <span>67 views</span>
            <span>Draft</span>
          </div>
        </div>
      </div>
      
      <div className="empty-state-message">
        <p>Educational resources help patients understand their conditions and treatment plans better.</p>
      </div>
    </div>
  );
};

export default Education;
